import { memo } from 'react'
import { SxProps } from '@mui/material'
import clsx from 'clsx'
import 'swiper/css/effect-fade'
import 'swiper/css/pagination'
import 'swiper/css/thumbs'

import { EffectFade, FreeMode, Pagination, Thumbs } from 'swiper/modules'

import Swiper, { SwiperSlide } from '../Swiper'
import { imageSwiperStyles as styles } from './ImageSlider.style'
import { Box } from '@/components/Layout'
import { swiperClasses } from '../Swiper.data'

import { ImageSliderProps, ImageThumbnailSliderProps } from './ImageSlider.types'
import { imageSliderClasses } from './ImageSlider.data'

import { Text } from '@/components/Data'

function ImageSlider({ images, showPagination = false, thumbsSwiper, ...props }: ImageSliderProps) {
  return (
    <Box sx={[styles.imageSwiperWrapper, styles.imageStyles] as SxProps}>
      <Swiper
        wrapperProps={{ sx: styles.wrapper }}
        swiperWrapperProps={{ sx: styles.swiperWrapper }}
        spaceBetween={0}
        effect={'slide'}
        navigation
        showNavigationButton={false}
        pagination={showPagination ? { clickable: true } : false}
        modules={[EffectFade, Pagination, Thumbs]}
        virtual
        slidesPerView={1}
        className="swiper-image"
        lazyPreloadPrevNext={2}
        thumbs={{ swiper: thumbsSwiper }}
        {...props}>
        {images?.map((image: string, index: number) => (
          <SwiperSlide key={index} virtualIndex={index}>
            <picture>
              <img
                src={image}
                alt=""
                loading="lazy"
                className={swiperClasses.swiperImageSliderImage}
              />
            </picture>
            <div className={swiperClasses.swiperLazyPreloader} />
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  )
}

export function ImageThumbnailSlider({
  images,
  onSwiper,
  activeIndex = 0,
}: ImageThumbnailSliderProps) {
  return (
    <Box sx={[styles.thumbnailWrapper, styles.imageStyles] as SxProps}>
      <Box sx={styles.thumbnailCountWrapper}>
        <Text sx={styles.thumbnailCountText}>
          {activeIndex + 1} / {images?.length}
        </Text>
      </Box>
      <Swiper
        onSwiper={onSwiper}
        spaceBetween={10}
        freeMode
        watchSlidesProgress
        showNavigationButton={false}
        modules={[FreeMode, Thumbs]}>
        {images?.map((image: string, index: number) => (
          <SwiperSlide key={index}>
            <Box
              sx={styles.thumbnailImageWrapper}
              className={clsx({
                [imageSliderClasses.thumb.active]: index === activeIndex,
              })}>
              <picture>
                <img src={image} alt="" />
              </picture>
            </Box>
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  )
}

export default memo(ImageSlider)
